import CategoryService from '@/lib/Category';
import { useQuery } from '@tanstack/react-query';
import useCurrentUser from './useCurrentUser';

export default function useCategory(id: string) {
    const { data: user } = useCurrentUser();

    const query = useQuery({
        queryKey: ['categories', id],
        queryFn: () => CategoryService.getCategory(id, true),
        enabled: !!id && !!user,
        refetchOnWindowFocus: false,
    });

    return query;
}